import { __assign } from "tslib";
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import TextAreaDefault from 'react-textarea-autosize';
// tslint:disable-next-line:no-duplicate-imports
import * as TextAreaAll from 'react-textarea-autosize';
/*
    very hacky, but turns out that there is a different between tests running
    and local environment / widget when it comes to the default exports.
    probably webpack (yoshi or sandbox) do something that our tests / browserify doesn't.
    this wasted enough time for now so the hack below is the best solution but if you see it
    later than April 2019 please try solve it again. 🙏🏻
 */
export var deprecatedTextAreaAutosizeKey = 'deprecated-text-area-autosize';
var TextArea = typeof TextAreaAll === 'object' ? TextAreaDefault : TextAreaAll;
var defaultProps = {
    disabled: false,
};
/** @deprecated please use \<TextArea/> */
export var DeprecatedTextAreaAutosize = function (partialProps) {
    var props = __assign(__assign({}, defaultProps), partialProps);
    var invalid = !!props.validationError;
    var classNames = namespacedClassnames(deprecatedTextAreaAutosizeKey, { invalid: invalid });
    var onChange = function (e) {
        props.onChange(e.target.value);
    };
    return (React.createElement(TextArea, { className: classNames, placeholder: props.placeholder, value: props.value, onChange: onChange, disabled: props.disabled, readOnly: props.readOnly, maxRows: props.maxRows }));
};
//# sourceMappingURL=text-area-autosize.js.map